import React from 'react';
import { Shield, Target, Users, Award } from 'lucide-react';

const AboutSection = () => {
  const values = [
    { icon: Shield, title: 'Confidentialité', description: 'Vos données sont protégées' },
    { icon: Target, title: 'Efficacité', description: 'Résultats garantis' },
    { icon: Users, title: 'Proximité', description: 'Accompagnement humain' },
    { icon: Award, title: 'Excellence', description: 'Service premium' }
  ];

  return (
    <section id="about" className="py-32 bg-black relative" data-testid="about-section">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C9A55C]/30 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Images */}
          <div className="relative order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="relative overflow-hidden gold-glow">
                  <img
                    src="https://customer-assets.emergentagent.com/job_service-devis-1/artifacts/bcqk9w6w_IMG_3513.jpeg"
                    alt="Jennifer - Travail administratif"
                    className="w-full h-[280px] object-cover object-center"
                  />
                  <div className="absolute inset-0 border border-[#C9A55C]/30" />
                </div>
                <div className="relative overflow-hidden gold-glow">
                  <img
                    src="https://customer-assets.emergentagent.com/job_service-devis-1/artifacts/ykjp9vtr_IMG_3978.jpeg"
                    alt="Banque"
                    className="w-full h-[200px] object-cover"
                  />
                  <div className="absolute inset-0 border border-[#C9A55C]/30" />
                </div>
              </div>
              <div className="pt-12">
                <div className="relative overflow-hidden gold-glow">
                  <img
                    src="https://customer-assets.emergentagent.com/job_service-devis-1/artifacts/znchczh0_8C5FD5EB-4DBF-4D20-8881-E70DC82BDE57.jpeg"
                    alt="Jennifer - Professionnelle"
                    className="w-full h-[450px] object-cover object-center"
                  />
                  <div className="absolute inset-0 border border-[#C9A55C]/30" />
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-10 order-1 lg:order-2">
            <div className="space-y-4">
              <span className="text-sm font-semibold tracking-[0.3em] uppercase text-[#C9A55C]">
                À propos
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-white leading-tight">
                L'excellence au service de votre organisation
              </h2>
            </div>

            <div className="space-y-6 text-white/70 leading-relaxed">
              <p>
                Je suis <strong className="text-[#C9A55C]">Jennifer Vanderbergue</strong>, Consultante IA & Automatisation, fondatrice de HELP'ADN.
              </p>
              <p>
                Je conçois des <strong className="text-[#C9A55C]">outils IA</strong>, des automatisations, des workflows intelligents, 
                des agents IA, des générateurs de documents et des solutions digitales administratives.
              </p>
              <p>
                J'accompagne les <strong className="text-[#C9A55C]">entreprises</strong>, les <strong className="text-[#C9A55C]">particuliers</strong> et 
                les <strong className="text-[#C9A55C]">associations</strong> dans leur structuration administrative, 
                leur mise en conformité et l'optimisation de leurs démarches.
              </p>
              <p className="text-sm text-white/50">
                Toutes mes prestations sont réalisées sur devis personnalisé.
              </p>
            </div>

            {/* Values */}
            <div className="grid grid-cols-2 gap-6 pt-6">
              {values.map((value, index) => (
                <div key={index} className="flex items-start gap-4 group">
                  <div className="w-12 h-12 border border-[#C9A55C]/30 flex items-center justify-center group-hover:border-[#C9A55C] group-hover:bg-[#C9A55C]/10 transition-all duration-300">
                    <value.icon className="w-5 h-5 text-[#C9A55C]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white">{value.title}</h3>
                    <p className="text-sm text-white/50">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Quote */}
            <blockquote className="relative pl-8 border-l-2 border-[#C9A55C] italic text-white/60 text-lg">
              "L'intelligence artificielle au service de l'excellence administrative."
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
